interface SongPairCardProps {
  trackPrevInfo: any;
  trackNextInfo: any;
  genre?: string;
}

export function SongPairCard({ trackPrevInfo, trackNextInfo, genre }: SongPairCardProps) {
  if (!trackPrevInfo || !trackNextInfo) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <p className="text-gray-500">加载歌曲信息...</p>
      </div>
    );
  }
  
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="font-bold text-lg mb-4">歌曲对信息</h3>
      
      <div className="grid md:grid-cols-2 gap-6">
        {/* 前一首歌 */}
        <div className="space-y-2">
          <div className="text-sm text-gray-500 font-medium">前一首歌</div>
          <div className="font-semibold text-lg">{trackPrevInfo.name}</div>
          <div className="text-gray-600">{trackPrevInfo.artist}</div>
          <div className="flex gap-4 text-sm text-gray-500 mt-2">
            <div>BPM: {trackPrevInfo.features.bpm}</div>
            <div>Key: {trackPrevInfo.features.key} {trackPrevInfo.features.keyMode}</div>
            <div>{trackPrevInfo.genre}</div>
          </div>
          {trackPrevInfo.albumCover && (
            <img
              src={trackPrevInfo.albumCover}
              alt="Album cover"
              className="w-32 h-32 object-cover rounded mt-2"
            />
          )}
        </div>
        
        {/* 转场箭头 */}
        <div className="hidden md:flex items-center justify-center">
          <div className="text-4xl text-sky-500">→</div>
        </div>
        
        {/* 后一首歌 */}
        <div className="space-y-2">
          <div className="text-sm text-gray-500 font-medium">后一首歌</div>
          <div className="font-semibold text-lg">{trackNextInfo.name}</div>
          <div className="text-gray-600">{trackNextInfo.artist}</div>
          <div className="flex gap-4 text-sm text-gray-500 mt-2">
            <div>BPM: {trackNextInfo.features.bpm}</div>
            <div>Key: {trackNextInfo.features.key} {trackNextInfo.features.keyMode}</div>
            <div>{trackNextInfo.genre}</div>
          </div>
          {trackNextInfo.albumCover && (
            <img
              src={trackNextInfo.albumCover}
              alt="Album cover"
              className="w-32 h-32 object-cover rounded mt-2"
            />
          )}
        </div>
      </div>
      
      {genre && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <span className="text-sm text-gray-500">流派分类: </span>
          <span className="text-sm font-medium">{genre}</span>
        </div>
      )}
    </div>
  );
}

